import {
	USER_CF_TYPE,
	REPORTER_TYPE,
	ASSIGNEE_TYPE,
	MULTI_USER_CF_TYPE,
	PEOPLE_CF_TYPE,
} from '@atlassian/jira-platform-field-config';
import type { StringValue, RichValue } from '../../../value/types';
import type { TransformedUser, TransformedUserField, TransformedMultiUserField } from '../types';

const getUserStringValue: StringValue<TransformedUserField> = (field) =>
	String(field.value?.name || '');

const getUsersStringValue: StringValue<TransformedMultiUserField> = (field) =>
	String(field.value.map((user) => user?.name).join(', ') || '');

export const userStringValueHandler = {
	[USER_CF_TYPE]: getUserStringValue,
	[REPORTER_TYPE]: getUserStringValue,
	[ASSIGNEE_TYPE]: getUserStringValue,
	[MULTI_USER_CF_TYPE]: getUsersStringValue,
	[PEOPLE_CF_TYPE]: getUsersStringValue,
};

const getUserRichValue: RichValue<TransformedUserField, TransformedUser> = (field) =>
	field.value || null;
const getUserListRichValue: RichValue<TransformedMultiUserField, Array<TransformedUser | null>> = (
	field,
) => field.value || [];

export const userRichValueHandler = {
	[USER_CF_TYPE]: getUserRichValue,
	[REPORTER_TYPE]: getUserRichValue,
	[ASSIGNEE_TYPE]: getUserRichValue,
	[MULTI_USER_CF_TYPE]: getUserListRichValue,
	[PEOPLE_CF_TYPE]: getUserListRichValue,
};
